module.exports = __webpack_public_path__ + "static/media/kitegateway_icon_light.6be90994.png";